import {
  RESPONSIVE_BREAKPOINT_VERSIONS,
  useResponsiveBreakpointsVersion
} from 'contexts/ResponsiveBreakpointsContext'

const useReleaseInformationResponsiveBreakpointsV2 = () =>
  useResponsiveBreakpointsVersion() === RESPONSIVE_BREAKPOINT_VERSIONS.V2

export default useReleaseInformationResponsiveBreakpointsV2
